/* Tabs block. Added by Oleg @ IAKOE.
   <ts-tabs> builds the header buttons from its .ts-tabs__panel children
   (data-ts-tab-label) — panels render server-side per child block, empty tabs
   render nothing. First panel is active; click/keyboard switches. */
if (!customElements.get('ts-tabs')) {
  customElements.define(
    'ts-tabs',
    class TsTabs extends HTMLElement {
      connectedCallback() {
        this.header = this.querySelector('.ts-tabs__header');
        this.panels = Array.from(this.querySelectorAll('.ts-tabs__panel'));

        if (!this.header || this.panels.length === 0) {
          this.style.display = 'none';
          return;
        }
        this.style.display = '';

        this.header.innerHTML = '';
        this.buttons = this.panels.map((panel, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ts-tabs__tab ia-font-body ia-uppercase';
          btn.setAttribute('role', 'tab');
          btn.textContent = panel.dataset.tsTabLabel || '';
          btn.addEventListener('click', () => this.activate(i));
          this.header.appendChild(btn);
          return btn;
        });

        this.activate(0);
      }

      activate(index) {
        this.buttons.forEach((b, i) => {
          b.classList.toggle('is-active', i === index);
          b.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
      }
    }
  );
}
